import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=2cbc685d&scoped=true&"
import script from "./CustomerHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=2cbc685d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc685d",
  null
  
)

export default component.exports